import { createFileRoute, notFound } from "@tanstack/react-router";
import { fundCompareSeachSchema } from "@funds/utils/fund-compare-search-params";
import { lazy } from "react";
import { fundQueryOptions, sipCalculatorQueryOptions } from "creso-core/hooks";
import { getFundsDateOverlapRange } from "@funds/utils/funds-date-overlap";

export const Route = createFileRoute("/(auth)/_headed/funds/_layout/compare")({
  component: RouteComponent,
  validateSearch: fundCompareSeachSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const { queryClient } = context;

    const {
      funds: fundIds,
      initial_investment,
      sip_amount,
      time_period,
    } = deps;

    if (!fundIds) {
      throw notFound();
    }

    const funds = await Promise.all(
      fundIds.map((fundId) =>
        queryClient.ensureQueryData(fundQueryOptions(fundId))
      )
    );

    const { startDate, endDate } = getFundsDateOverlapRange(funds, time_period);

    await Promise.all(
      fundIds.map((f) =>
        queryClient.prefetchQuery(
          sipCalculatorQueryOptions({
            sipAmount: Number(sip_amount),
            lumpsumAmount: Number(initial_investment),
            startDate,
            sipFrequency: "Monthly",
            endDate,
            fundId: f,
          })
        )
      )
    );
  },
});

const FundsComparePage = lazy(() => import("@funds/pages/funds-compare"));

function RouteComponent() {
  return <FundsComparePage />;
}
